import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Flex } from "antd";
import { t } from "i18next";
import { PropsWithChildren } from "react";
import style from "./Slide.module.scss";

interface SlideWrapperProps {
  goBackHandler: () => void;
  title: string;
}

const SlideWrapper = ({
  children,
  title,
  goBackHandler,
}: PropsWithChildren & SlideWrapperProps) => {
  return (
    <Flex flex={1} justify="center" gap={20} vertical>
      <Button className={style.goBackBtn} type="link" onClick={goBackHandler}>
        <Flex gap={20}>
          <ArrowLeftOutlined />
          {t("COMMON.NAZAD")}
        </Flex>
      </Button>
      <Flex className={style.textWrapper} vertical>
        <span className={style.cardTitle}>{title}</span>
        {children}
      </Flex>
    </Flex>
  );
};

export default SlideWrapper;
